import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  .ant-select-item.ant-select-item-option.ant-select-item-option-selected {
    background-color: ${({ theme }: any) => theme.hoveredDiv};
  }

  .ant-select-item-option-selected:not(.ant-select-item-option-disabled) .ant-select-item-option-state {
    color: ${({ theme }) => theme.primary};
  }

  .ant-select:not(.ant-select-disabled):hover .ant-select-selector,
  .ant-input-affix-wrapper:hover {
    border-color: ${({ theme }) => theme.primary};
  }

  .ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector {
    box-shadow: 0 0 2px ${({ theme }) => theme.primary};
    border-color: ${({ theme }) => theme.primary};
  }

  .ant-picker:hover, .ant-picker-focused,
  .ant-picker-cell-in-view.ant-picker-cell-today .ant-picker-cell-inner::before {
    border-color: ${({ theme }) => theme.primary};
  }

  .ant-picker-focused {
    box-shadow: 0 0 0 2px ${({ theme }: any) => theme.hoveredDiv};
  }

  .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner, .ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner, .ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner {
    background: ${({ theme }) => theme.primary};
  }

  .ant-picker-now .ant-picker-now-btn {
    color: ${({ theme }) => theme.primary};
  }

  .ant-btn-primary {
    background: ${({ theme }) => theme.primary};
    border-color: ${({ theme }) => theme.primary};

    &:hover {
      background-color: ${({ theme }) => theme.primary};
      border-color: ${({ theme }) => theme.hoveredDiv};
    }
  }

  .ant-picker-header-view button:hover,
  .ant-picker-today-btn,
  .ant-picker-today-btn:hover {
    color: ${({ theme }) => theme.primary};
  }

  .ant-input-affix-wrapper:focus, .ant-input-affix-wrapper-focused {
    box-shadow: 0 0 2px ${({ theme }) => theme.primary};
    border-color: ${({ theme }) => theme.primary};
  }

  .ant-input {
    border-radius: 3px;

    &:hover, &:focus {
      border-color: ${({ theme }) => theme.primary};
    }

    &:focus {
      box-shadow: 0 0 2px ${({ theme }) => theme.primary};
    }
  }

  .ant-radio-checked .ant-radio-inner,
  .ant-radio-wrapper:hover .ant-radio, .ant-radio:hover .ant-radio-inner, .ant-radio-input:focus + .ant-radio-inner {
    border-color: ${({ theme }) => theme.primary};
  }

  .ant-radio-checked::after {
    border-color: ${({ theme }) => theme.primary};
  }

  .ant-radio-inner::after {
    background-color: ${({ theme }) => theme.primary};
  }

  .ant-modal-confirm-btns {
    .ant-btn:not(.ant-btn-primary):not(.ant-btn-dangerous) {
      &:hover, &:active, &:focus {
        border-color: ${({ theme }) => theme.primary};
        color: ${({ theme }) => theme.primary};
      }
    }

    .ant-btn-primary {
      background-color: ${({ theme }) => theme.primary};
      border-color: ${({ theme }) => theme.primary};

      &:hover, &:active, &:focus {
        background-color: ${({ theme }) => theme.primary};
        border-color: ${({ theme }) => theme.primary};
      }
    }
  }
`;
